import { isDate } from 'date-fns';

import { formatDate, formatTime } from '@blaze-shared/shared-util';

const ONE_DAY_IN_MS = 86_400_000;

export function getChatMessageTime(value: string | Date | number | null | undefined): string {
  if (!value) {
    return '';
  }

  let date: Date;
  if (isDate(value)) {
    date = value as Date;
  } else if (typeof value === 'string' || typeof value === 'number') {
    date = new Date(value);
  } else {
    return '';
  }

  const now = new Date();
  const diff = now.getTime() - date.getTime();

  if (diff < ONE_DAY_IN_MS && now.getDate() === date.getDate()) {
    return formatTime(date.toISOString()) || '';
  } else {
    return formatDate(true)(date.toISOString()) || '';
  }
}
